import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { MdOutlineFileUpload } from "react-icons/md";
import { utils, writeFile } from "xlsx";
import * as XLSX from "xlsx";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";
import Select  from "react-select"
import redirectURL from "../redirectURL"
import "../../assets/css/inventorymanagement.css"

const PlantDestinationMaster = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [uploadedFileData, setUploadedFileData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [file, setFile] = useState(null)
  const [isLoadTrue, setIsLoadTrue] = useState(true)
  const [plantOptions , setPlantOptions] = useState([])
  const [destinationOptions, setDestinationOptions] = useState([])
  const [uniqueId , setUniqueId] = useState("")
  const [destinationType, setDestinationType] = useState("")
  
  const [editFormData, setEditFormData] = useState({
    destination_store_id: "",
    plant_id: "",
    transit_days : ""
  });
  const [duplicatedEditData, setDuplicatedEditData] = useState({
    destination_store_id: "",
    plant_id: "",
    transit_days : ""
  });


  
    const columnWithDefs = [
  {
    headerName: "",
    field: "actions",
    sortable: false,
    filter: false,
    width: "90px",
    cellClass: "custom-cell", 
    cellRendererFramework: (params) => (
      <div
        style={{
          height: "36px", 
          padding: 0, 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center"
        }}
      >
        <button
          title="Edit"
          className="mt-2"
          style={{
            height: "30px", 
            width: "60px",  // Adjust width to ensure the button fits
            padding: "0 10px",  // Optional: Adjust padding for appearance
            border: "1px solid #93385D",
            borderRadius: "4px",
            cursor: "pointer",
            backgroundColor: "#F4EBEF",  // Optional: Customize the background color
            fontSize: "0.8rem",  // Optional: Adjust font size for readability
            color: "#93385D" // Optional: Customize button text color;
          }}
          onClick={() => handleEdit(params.data)}
        >
          Edit
        </button>
      </div>
    ),
  },
  {
    headerName: "",
    field: "delete",
    sortable: false,
    filter: false,
    width: "90px",
    cellClass: "custom-cell", 
    cellRendererFramework: (params) => (
      <div style={{
        height: "36px", 
          padding: 0, 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center"
      }}>
          <button
              title="Delete"
              style={{
                height: "30px",
                width: "60px",
                backgroundColor: "transparent",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => handleDelete(params.data)}
            >
            <RiDeleteBin5Line style={{ color: "red", fontSize: "20px" }} />
          </button>
      </div>
    
    ),
  },
  {
    headerName: "Destination Store ID",
    field: "destination_store_id",
    sortable: true,
    resizable: true,
    flex : 1

  },
  {
    headerName: "Destination Store Name",
    field: "destination_store_name",
    sortable: true,
    
    resizable: true,
    flex : 1
  },
    {
    headerName: "Destination Type",
    field: "destination_type",
    sortable: true,
    resizable: true,
    flex : 1,
    valueGetter: (params) => {
      if (params.data.destination_type === "warehouse") {
        return "Warehouse";
      } else if (params.data.destination_type === "darkstore") {
        return "Dark Store";
      } else {
        return "Unknown";
      }
    }
  },
  {
    headerName: "Source ID",
    field: "plant_id",
    sortable: true,
    
    resizable: true,
    flex : 1
  },
  {
    headerName: "Source Name",
    field: "plant_name",
    sortable: true,
    
    resizable: true,
    flex : 1

  },

  {
    headerName: "Transit Days",
    field: "transit_days",
    sortable: true,
    // filter: "agNumberColumnFilter",
    resizable: true,
    flex : 1

  }
];
    

  const resetFormData = () => {
    setEditFormData({ 
     plant_id: "",
      plant_name: "",
      destination_store_id: "",
      destination_store_name: "",
      transit_days: "",
    });
    setDuplicatedEditData({
      plant_id: "",
      plant_name: "",
      destination_store_id: "",
      destination_store_name: "",
      transit_days: "",
    });
  };
  
  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData()
    setUploadedFileData([]);
  };

  const onClickAddNewProduct = async () => {
   
    resetFormData();
    setSliderOpen(true);
    setSliderType(1)
    setSliderCl("slider-25");
    setSliderTitle("Add New Mapping");
    setOverlyBlock("show-m");
  }
    const handleEdit = async(row) => {
    const response = await redirectURL.post("masters/getDestinationType", {destination_store_id : row.destination_store_id})
    const type = response.data.data[0]
    setDestinationType(type)

    setSliderOpen(true);
    setSliderType(3); 
    setSliderCl("slider-25");
    setSliderTitle(`Edit Mapping - ${row.destination_store_id}`);
    setOverlyBlock("show-m");
    setUniqueId(row._id)
    setEditFormData({
      plant_id: row.plant_id || "",
      // plant_name: row.plant_name || "",
      destination_store_id: row.destination_store_id || "",
      // destination_store_name: row.destination_store_name || "",
      transit_days: row.transit_days || "",
    });

    setDuplicatedEditData({
      plant_id: row.plant_id || "",
      // plant_name: row.plant_name || "",
      destination_store_id: row.destination_store_id || "",
      // destination_store_name: row.destination_store_name || "",
      transit_days: row.transit_days || "",
    });
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setUniqueId(row._id)
    setShowDeletePopup(true);
    setOverlayBlock("show-m");
   
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
      statusPanels: [
          {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left"
          },
          {
              statusPanel: "agTotalRowCountComponent",
              align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
      ]
  }
  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  }

  const getSkuMasterData = async () => {
    try{
      const response = await redirectURL.post("masters/getPlantDestinationMasterData", {})
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
          setLoadshow("show-n");
          setOverlayBlock("show-n");
        } else {
          setBasicTitle("No Mappaing master data found");
          setBasicType("info");
          setShow(true);
        }
      }
    }
    catch (error) {
      console.error("Error fetching Mapping master data:", error);
      setBasicTitle("Failed to fetch Mapping master data");
      setBasicType("error");
      setShow(true);
    }
  }

  const getDistictPlantCodes = async() => {
    try{
          const response = await redirectURL.post("masters/getDistictPlantCodes", {})
          if (response.status === 200) {
            if (response.data.data && response.data.data.length > 0) {
              const responseData = response.data.data
              const plantOptions = responseData.map(item => ({label : item, value : item}))
              setPlantOptions(plantOptions);
              // setLoadshow("show-n");
              // setOverlayBlock("show-n");
            } else {
              setBasicTitle("No Mapping master data found");
              setBasicType("info");
              setShow(true);
            }
          }
        }
        catch (error) {
          console.error("Error fetching Mapping master data:", error);
          setBasicTitle("Failed to fetch Mapping master data");
          setBasicType("error");
          setShow(true);
        }
  }

  const getDistinctDestinationCodes = async () => {
     try{
      const response = await redirectURL.post("masters/getDistinctDestintionCodes", {})
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const responseData = response.data.data
          const destinationOptions = responseData.map(item => ({label : item, value : item}))
          setDestinationOptions(destinationOptions);
          // setLoadshow("show-n");
          // setOverlayBlock("show-n");
        } else {
          setBasicTitle("No Mapping master data found");
          setBasicType("info");
          setShow(true);
        }
      }
    }
    catch (error) {
      console.error("Error fetching Mapping master data:", error);
      setBasicTitle("Failed to fetch Mapping master data");
      setBasicType("error");
      setShow(true);
    }
  }


  useEffect(() => {
    const getData = async () => {
      setLoadshow("show-m");  
      setOverlayBlock("show-m");
        await getSkuMasterData()
        await getDistictPlantCodes()
        await getDistinctDestinationCodes()
        setLoadshow("show-n");  
        setOverlayBlock("show-n");
      }
    getData()

  }, []);

const closeAlert = () => {
  const fileInput = document.getElementById("bulkUploadFile");
   if (fileInput !== null) {  // Check if the element exists
    fileInput.value = "";  // Clears the input if element exists
  }
  setUploadedFileData([]);
  setFile(null)
  setShow(false);
  setLoadshow("show-n");
  setOverlayBlock("show-n");
  setOverlyBlock("show-n");
  setSliderOpen(false);
  setShowDeletePopup(false) 
  // if (isLoadTrue) {
  //   window.location.reload()
  // }
};

const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    if (document.getElementById("bulkUploadFile")) {
      document.getElementById("bulkUploadFile").value = "";
    }
    resetFormData();
    setUploadedFileData([]);
  };

const downloadExcelTemplate = () => {
    const sampleData = [
      [
       
        "Destination Store Id",
        "Plant Id",
        "Transit Days"
      ]
    ];

    const ws = utils.aoa_to_sheet(sampleData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    writeFile(wb, "sample_dest_plant_map_template.xlsx");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.value)
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false,
        dateNF: "yyyy-mm-dd",
      });
      
      const mapping = {
    
        "Destination Store Id": "destination_store_id",
        "Plant Id": "plant_id",
        "Transit Days" : "transit_days"
      };

      function toSnakeCase(str) {
          return str
            .trim()
            .replace(/\s+/g, '_')           // replace spaces with underscores
            .replace(/[A-Z]/g, letter => letter.toLowerCase()) // lowercase any capitals
            .replace(/[^a-z0-9_]/g, '')     // remove any special chars if needed
        }

      const result = parsedData.map(item => {
        const newItem = {};
        for (const key in item) {
          if (mapping[key]) {
            newItem[mapping[key]] = item[key];
          } else {
            newItem[toSnakeCase(key)] = item[key];
          }
        }
        return newItem;
      });

      console.log("Parsed Data:", result);
      setUploadedFileData(result);
    };
    reader.readAsArrayBuffer(file);
  };

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata)
  }
  
  // const onClickingFileSubmit = async () => {
  //   if (uploadedFileData.length === 0) {
  //       setShow(true);
  //       setBasicType("info");
  //       setBasicTitle("Please upload a file");
  //       return;
  //   }

  //   const params = { masterData: uploadedFileData };
  //     try {
  //       const response = await redirectURL.post(
  //         "masters/storeDestinationPlantMapping",
  //         params
  //       );
  //       if (response.data.status === "success") {
  //         setUploadedFileData([])
  //         await getSkuMasterData();
  //         setLoadshow("show-n");
  //         setOverlayBlock("show-n");
  //         setShow(true);
  //         setBasicType("success");
  //         setBasicTitle("Data Uploaded Successfully");

  //         // User Action Triggering Starts Here
  //       var userData = {
  //         email: localStorage.getItem("email"),
  //         user_code: localStorage.getItem("user_code"),
  //         action: "Plant Destination Mapping File Upload - Success",
  //       }
  //       triggerUserAction(userData)
  //     // User Action Triggering Ends Here
  //       } else {
  //         setLoadshow("show-n");
  //         setOverlayBlock("show-n");
  //         setShow(true);
  //         setBasicType("info");
  //         setBasicTitle("Data Upload Failed");
  //         setIsLoadTrue(true)

  //         // User Action Triggering Starts Here
  //       var userData = {
  //         email: localStorage.getItem("email"),
  //         user_code: localStorage.getItem("user_code"),
  //         action: "Plant Destination Mapping File Upload - Failure",
  //       }
  //       triggerUserAction(userData)
  //     // User Action Triggering Ends Here
  //       }
  //     } catch (error) {
  //       const errorMessage = error.response?.data?.message || "An error occurred";
  //       setUploadedFileData([])
  //       setShow(true);
  //       setBasicType("info");
  //       setBasicTitle(errorMessage);

  //       // User Action Triggering Starts Here
  //       var userData = {
  //         email: localStorage.getItem("email"),
  //         user_code: localStorage.getItem("user_code"),
  //         action: "Plant Destination Mapping File Upload - Failure",
  //       }
  //       triggerUserAction(userData)
  //     // User Action Triggering Ends Here
  //     }
  // };

  // const onClickUploadSkuMasterData = (event) => {
  //   setUploadedFileData([])
  //   setSliderOpen(true);
  //   setSliderType(2);
  //   setSliderCl("slider-25");
  //   setSliderTitle("Upload Plant Destination Mapping Data");
  //   setOverlyBlock("show-m");
  // };

  const onClickingUpdateSkuData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");  
    const params = {  
      unique_id : uniqueId,
      data: {
        plant_id: editFormData.plant_id,
        destination_store_id: editFormData.destination_store_id,
        transit_days: editFormData.transit_days,
        type : destinationType
      }
    };
    // console.log("Params for Update Mapping : ", params)

    const isNeedtoUpdate = Object.keys(duplicatedEditData).some(
      (key) => duplicatedEditData[key] !== editFormData[key]
    );

    if (!isNeedtoUpdate) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("No changes made to mapping data");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }

    try {
      const response = await redirectURL.post(
        "masters/updateDestinationplantMappingData",
        params
      );

      if (response.data.status === "success") {
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Mapping updated successfully");

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Updated Plant Destination Mapping",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
      // User Action Triggering Ends Here
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to update mapping");

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Updated Plant Destination Mapping",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
      // User Action Triggering Ends Here
      }
      
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to update Mapping");

      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Updated Plant Destination Mapping",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
    // User Action Triggering Ends Here
    }
  }

  const handleAddSkuProduct = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = {
      plant_id: editFormData.plant_id,
      destination_store_id: editFormData.destination_store_id,
      transit_days: editFormData.transit_days,
      type : destinationType
    };
    const validationErrors = Object.keys(params).filter(
      (key) => !params[key] || params[key].trim() === ""
    );

    if (validationErrors.length > 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle(`Please fill in all required fields: ${validationErrors.join(", ")}`);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }
    try {
      const response = await redirectURL.post(
        "masters/addNewDestinationPlantMapping",
        params
      );
   
      if (response.status === 200 && response.data.status === "success") {
        await getSkuMasterData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("New Mapping Added Successfully");
        // setRowData((prevRowData) => [...prevRowData, params]);

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Added New Plant Destination Mapping",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
      // User Action Triggering Ends Here

      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(response.data.message);  
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Added New Plant Destination Mapping",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
      // User Action Triggering Ends Here
      }
     
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to add New Mapping");

      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Added New Plant Destination Mapping",
          status: "Failure",
          path: window.location.pathname
      }
      triggerUserAction(userData)
    // User Action Triggering Ends Here
    }
  }

  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = { unique_id: uniqueId };
    try { 
      const response = await redirectURL.post(
        "masters/deleteDestinationPlantMapping",
        params
      );
    
      if (response.data.status === "success") {
        await getSkuMasterData()
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("Mapping Deleted Successfully");
        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Deleted New Plant Destination Mapping",
          status: "Success",
          path: window.location.pathname
        }
        triggerUserAction(userData)
      // User Action Triggering Ends Here
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to delete Mapping");

        // User Action Triggering Starts Here
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Deleted New Plant Destination Mapping",
          status: "Failure",
          path: window.location.pathname
        }
        triggerUserAction(userData)
      // User Action Triggering Ends Here
      }
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete Mapping");
      // User Action Triggering Starts Here
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Deleted New Plant Destination Mapping",
        status: "Failure",
        path: window.location.pathname
      }
      triggerUserAction(userData)
    // User Action Triggering Ends Here
    }
  };

  const onClickDeletePopupCancelBtn = () => {
      setOverlayBlock("show-n");
      setShowDeletePopup(false);
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
              <SweetAlert
                  show={show}
                  type={basicType}
                  title={basicTitle}
                  onConfirm={closeAlert}
                  style={{ fontSize: "9px" }}
              >
              </SweetAlert>
          </div>

        <div className="row" style={{fontSize: "1rem", fontWeight: "bold", fontFamily: "Arial, sans-serif"}}>
          <div className="col-sm-12">
            <h1 className="col-sm-12" style={{color : "#B9366D", fontSize : "18px", fontWeight : "bold", fontFamily : "sans-serif"}}>Source Destination Mapping Master</h1>
          </div>
          <div style={addButtonContainerStyle} className="col-sm-12 text-right pr-0 mb-4">
              <button 
                  onClick={onClickAddNewProduct}
                  style={{
                    ...addButtonStyle,
                      backgroundColor: "#93385D",
                      color: "#fff",
                      border: "2px solid #93385D",
                      marginRight : 15
                  }}
                  >
                    <IoMdAdd style={{color : "#fff", fontSize :"18px"}}/>
                    {" Add"}
              </button>
              {/* <button
              onClick={onClickUploadSkuMasterData}

                className="mr-2"
                style={{
                  ...addButtonStyle,
                  backgroundColor: "#F4EBEF",
                  color: "#93385D",
                  border: "2px solid #93385D",
                }}
            >
              < MdOutlineFileUpload style={{color : "#93385D", fontSize :"20px"}}/>
              &nbsp;
              Upload
            </button> */}
            </div>
            <div className="col-sm-12 p-0 pl-2 mt-6">
              <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                  <AgGridReact
                    rowData={rowData}
                    columnDefs={columnWithDefs}
                    defaultColDef={defaultColDef}
                    domLayout="normal"
                    sideBar={sideBar}
                    statusBar={statusPanel}
                    pagination={true}
                    paginationPageSize={100}
                    enableRangeSelection={true}
                    gridOptions={{
                      suppressHorizontalScroll: false
                    }}
                  />
              </div>
          </div>
          <div>

          </div>
        </div>
      </div>
      <div
        className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
        style={{width : "25%"}}
      >
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p
            className="m-0p"
            style={{ cursor: "pointer" }}
            onClick={onClickingSliderCloseIcon}
          >
            X&nbsp;&nbsp;&nbsp;
          </p>

        </div>

        {sliderType === 1 && (
          <form style={{ padding: "20px" }}>
            {/* Destination Store Id */}
            <div className="form-group">
              <label htmlFor="destination" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Destination Store Id<span style={{ color: "red" }}>{" *"}</span></label>
              <div id="destination" >
                <Select
                  options={destinationOptions}
                  placeholder="Select Option"
                  value={
                    editFormData.destination_store_id
                      ? { label: editFormData.destination_store_id, value: editFormData.destination_store_id }
                      : null
                  }
                  onChange={async (option) => {
                    setEditFormData({
                      ...editFormData,
                      destination_store_id: option.value
                    });
                    try {
                      const response = await redirectURL.post(
                        "masters/getDestinationType",
                        { destination_store_id: option.value }
                      );
                      const type = response.data.data[0];
                      setDestinationType(type);
                    } catch (err) {
                      console.error("Error fetching destination types", err);
                    }
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="plantId" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Source Id <span style={{ color: "red" }}>{" *"}</span></label>
              <div id="plantId" >
                <Select
                  isDisabled={!editFormData.destination_store_id}   // ✅ actually disables it
                  options={
                    destinationType === "warehouse"
                      ? plantOptions
                      : destinationOptions.filter(
                        (item) => item.value !== editFormData.destination_store_id
                      )
                  }
                  value={
                    editFormData.plant_id
                      ? { label: editFormData.plant_id, value: editFormData.plant_id }
                      : null
                  }
                  onChange={(option) =>
                    setEditFormData({ ...editFormData, plant_id: option.value })
                  }
                  placeholder={editFormData.destination_store_id ? "" : ""}
                  styles={{
                    control: (base) => ({
                      ...base,
                      backgroundColor: "#fff",
                    }),
                  }}
                />
              </div>
            </div>

            {/* Transit Days */}
            <div className="form-group">
              <label htmlFor="transitDays" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Transit Days<span style={{ color: "red" }}>{" *"}</span></label>
              <div id="transitDays">
                <input
                  type="number"
                  className="form-control"
                  id="plant_name"
                  name="plant_name"
                  value={editFormData.transit_days}
                  onChange={(e) => setEditFormData({ ...editFormData, transit_days: e.target.value })}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem"
                  }}
                />
              </div>
            </div>

            {/* Add Button */}
            <div style={{ textAlign: "right", marginTop: "10px" }}>
              <button
                type="submit"
                id="sample-download-button"
                onClick={(e) => {
                  e.preventDefault();
                  handleAddSkuProduct();
                }}
              >
                ADD
              </button>
            </div>
          </form>
        )}
        {/* {sliderType === 2 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              padding: 5,
            }}
          >
            <div style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }}>
              <div className="d-flex justify-content-end mb-10p">
                <button
                  id = "sample-download-button"
                  onClick={downloadExcelTemplate}
                >
                  {"Download Sample Template"}
                </button>
              </div>
              <input
                type="file"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                style={{
                  border: "1px solid lightgrey",
                  width: "100%",
                  padding: "8px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                  color: "#000",
                  fontSize: "13px",
                }}
                id="bulkUploadFile"
              />
              <p
                style={{
                  color: "red",
                  fontSize: "13px",
                  margin: "0px",
                  marginTop: "10px",
                }}
              >
                *Accept .csv & .xlsx files only
              </p>
              <div style={{ textAlign: "right", marginTop: "10px" }}>
                <button
                  style={{
                    backgroundColor: "#93385D",
                    color: "#fff",
                    fontSize: "0.8rem",
                  }}
                  onClick={(e)=> {
                    e.preventDefault()
                    setLoadshow("show-m")
                    setOverlayBlock("show-m")
                    onClickingFileSubmit(e)
                  }}
                >
                  {"Submit"}
                </button>
              </div>


            </div>
          </div>
      )} */}
      
      {sliderType === 3 && (
        <form style={{ padding: "20px" }}
         onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation()
                onClickingUpdateSkuData();
              }}>
          <div className="form-group">
            <label htmlFor="destination_store_id" style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: "5px",
              display: "block"
            }}>Destination Store Id <span style={{color :"red"}}>*</span></label>
            <input
              type="text"
              className="form-control"
              id="destination_store_id"
              name="destination_store_id"
              value={editFormData.destination_store_id}
              // onChange={(e) => setEditFormData({ ...editFormData, destination_store_id: e.target.value })}
              placeholder="Enter Plant Id"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                fontSize: "0.9rem",
                backgroundColor: "#f9f9f9",
                cursor: "not-allowed",
              }}
              disabled  // ⬅️ this makes the field read-only
              required
            />
          </div>
          <div className="form-group">
              <label htmlFor="plant_id" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Source Id <span style={{color :"red"}}>{" *"}</span></label>
              <div id="plant_id" >
                <Select
                  options={destinationType === "warehouse" ? plantOptions :  destinationOptions.filter(item => item.value !== editFormData.destination_store_id)}
                  value={{label : editFormData.plant_id, value: editFormData.plant_id}}
                  onChange={(option) => setEditFormData({ ...editFormData, plant_id: option.value })}
                  required

                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="transitDays" style={{
                fontSize: "0.9rem",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "5px",
                display: "block"
              }}>Transit Days<span style={{color :"red"}}>{" *"}</span></label>
              <div id="transitDays">
                <input
                type="number"
                className="form-control"
                id="plant_name"
                name="plant_name"
                value={editFormData.transit_days}
                onChange={(e) => setEditFormData({ ...editFormData, transit_days: e.target.value })}
                placeholder="Enter Plant Name"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "0.9rem"
                }}
                required
              />
              </div>
            </div>
          <div style={addButtonContainerStyle}>
            <button
              type="submit"
              id = "sample-download-button"

              // className="btn btn-success"
             
            >
              Update
            </button>
          </div>
        </form>
    )}
      </div>
           {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "40%",
            left: "40%",
            zIndex: "1003",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <div className="inventory-delete-popup">
            <p
              style={{
                color: "grey",
                fontSize: "19px",
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
             {`Are you sure you want to delete ${selectedRow ? selectedRow.destination_store_id +"-"+ selectedRow.plant_id : ""} Mapping ?`}

            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-danger"
                onClick={onClickingPopupDeleteBtn}
              >
               Delete
              </button>
              <button
                className="btn btn-secondary"
                onClick={onClickDeletePopupCancelBtn}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
<div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
      <div
          className={"overly-block " + overlyBlock}
          onClick={hideOverlySlideBlock}
        >
    </div>
    </>
  );
};

const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
  padding: "5px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily :"sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
};

export default PlantDestinationMaster;
